import React from 'react';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';

interface Props {
	formDisabled: boolean;
	takeProfitInvalid: boolean;
	takeProfitInvalidReason?: 'entry' | 'immediate' | 'reference' | null;
	stopLossInvalid: boolean;
	positionIsLong: boolean;
	isStopLossBeyondLiquidationPrice: boolean;
	stopLossInvalidReason?: 'entry' | 'immediate' | 'reference' | null;
}

const TpSlOrderFormMessage = React.memo(function TpSlOrderFormMessage({
	formDisabled,
	takeProfitInvalid,
	takeProfitInvalidReason,
	stopLossInvalid,
	positionIsLong,
	isStopLossBeyondLiquidationPrice,
	stopLossInvalidReason,
}: Props) {
	if (
		!formDisabled &&
		!takeProfitInvalid &&
		!stopLossInvalid &&
		!isStopLossBeyondLiquidationPrice
	) {
		return null;
	}

	return (
		<div className="flex flex-col gap-y-2">
			{formDisabled && (
				<InlineAlert
					variant="warning"
					title="Must specify a valid order size"
				/>
			)}

			{takeProfitInvalid && (
				<InlineAlert
					variant="error"
					title={`Take profit price must be ${
						positionIsLong ? 'above' : 'below'
					} the ${
						takeProfitInvalidReason === 'reference' ? 'reference' : 'entry'
					} price`}
				/>
			)}

			{stopLossInvalid && (
				<InlineAlert
					variant="error"
					title={
						stopLossInvalidReason === 'immediate'
							? `This stop loss would execute immediately because it's ${
									positionIsLong ? 'at or above' : 'at or below'
								} the current reference price`
							: `Stop loss price must be ${
									positionIsLong ? 'below' : 'above'
								} the ${
									stopLossInvalidReason === 'reference' ? 'reference' : 'entry'
								} price`
					}
				/>
			)}

			{/* Show warning for liquidation price even when other errors exist */}
			{isStopLossBeyondLiquidationPrice && (
				<InlineAlert
					variant="warning"
					title={
						positionIsLong
							? 'Stop loss is recommended to be above the estimated liquidation price'
							: 'Stop loss is recommended to be below the estimated liquidation price'
					}
				/>
			)}
		</div>
	);
});

export default TpSlOrderFormMessage;
